import { Link } from "react-router-dom";
import { Activity } from "lucide-react";
import { ThemeToggle } from "@/components/ThemeToggle";
import { Button } from "@/components/ui/button";

export const PublicNav = () => (
  <header className="sticky top-0 z-40 glass border-b border-border">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
      <Link to="/" data-testid="nav-home-logo" className="flex items-center gap-2">
        <Activity className="h-4 w-4 text-primary" />
        <span className="font-display font-bold tracking-tight">DevOps Mentor AI</span>
      </Link>
      <div className="flex items-center gap-1 sm:gap-4">
        <Link to="/" data-testid="nav-home" className="hidden sm:block text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">Home</Link>
        <Link to="/pricing" data-testid="nav-pricing" className="hidden sm:block text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">Pricing</Link>
        <Link to="/faq" data-testid="nav-faq" className="hidden sm:block text-sm text-muted-foreground hover:text-foreground transition-colors duration-150">FAQ</Link>
        <ThemeToggle />
        <Link to="/login" data-testid="nav-signin">
          <Button variant="ghost" size="sm" className="rounded-none">Sign In</Button>
        </Link>
        <Link to="/register" data-testid="nav-start-assessment">
          <Button size="sm" className="rounded-none">Start Free Assessment</Button>
        </Link>
      </div>
    </div>
  </header>
);

export const PublicFooter = () => (
  <footer className="border-t border-border mt-24">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-10 flex flex-col sm:flex-row justify-between gap-6 text-sm text-muted-foreground">
      <div>
        <p className="font-display font-bold text-foreground">DevOps Mentor AI</p>
        <p className="mt-1 font-mono text-xs">from developer to DevOps, with evidence.</p>
      </div>
      <div className="flex gap-8">
        <Link to="/pricing" className="hover:text-foreground transition-colors duration-150">Pricing</Link>
        <Link to="/faq" className="hover:text-foreground transition-colors duration-150">FAQ</Link>
        <Link to="/login" className="hover:text-foreground transition-colors duration-150">Sign In</Link>
      </div>
    </div>
  </footer>
);
